import React from "react";

function WarningIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64878 2.25003L16.7933 14.625C16.8591 14.739 16.8938 14.8684 16.8938 15C16.8938 15.1317 16.8591 15.261 16.7933 15.375C16.7275 15.489 16.6328 15.5837 16.5188 15.6495C16.4048 15.7154 16.2754 15.75 16.1438 15.75H1.85478C1.72313 15.75 1.5938 15.7154 1.47978 15.6495C1.36577 15.5837 1.2711 15.489 1.20527 15.375C1.13945 15.261 1.1048 15.1317 1.1048 15C1.1048 14.8684 1.13945 14.739 1.20528 14.625L8.34978 2.25003C8.41561 2.13602 8.51028 2.04135 8.62429 1.97553C8.73831 1.90971 8.86763 1.87506 8.99928 1.87506C9.13092 1.87506 9.26025 1.90971 9.37426 1.97553C9.48827 2.04135 9.58295 2.13602 9.64878 2.25003ZM8.24928 12V13.5H9.74928V12H8.24928ZM8.24928 6.75003V10.5H9.74928V6.75003H8.24928Z"
        fill="#CC0300"
      />
    </svg>
  );
}

export default WarningIcon;
